import * as React from 'react'
import { RouterAction, routerActions } from 'react-router-redux'
import { connect, Dispatch } from 'react-redux'
import { LoadingSpinner } from '../components/LoadingSpinner'
import { ActionType, Actions } from '../actions/signIn'
import { StoreState } from '../reducers'
import * as Auth from '../services/auth/auth'
import { ROUTES } from '../constants/routes'
import '../styles/App.scss'
import { ActionType as ErrorInfoActionType, Actions as ErrorActions } from '../actions/errorInfo'
import { Error as ErrorInfo } from "../types/Errors/Error";
import Mapper from '../utils/Mapper';

interface LogOutProps {
    isSigned: boolean
    onLogOut: () => ActionType
    routePush: (location: string) => RouterAction
    onErrorEvent: (errorInfo: ErrorInfo) => ErrorInfoActionType
}

interface LogOutState {
    isLogoutInProcess: boolean
}

class LogOut extends React.Component<LogOutProps, LogOutState> {

    constructor(props: any) {
        super(props)
        this.state = {
            isLogoutInProcess: false
        }
    }

    componentDidMount() {
        if (this.props.isSigned) {
            Auth.signOut()
            .then((res: any) => {
                this.props.onLogOut()
                this.setState({
                    isLogoutInProcess: false
                })
                this.props.routePush(ROUTES.ROOT)
            })
            .catch((error: any) => {
                this.setState({
                    isLogoutInProcess: false
                })
                console.log(error)
                this.props.onErrorEvent(Mapper.mapError(error))
            })
            this.setState({
                isLogoutInProcess: true
            })
        } else {
            this.props.routePush(ROUTES.ROOT)
        }
    }

    render() {
        return (
            <div className="App starting-page">
                <LoadingSpinner show={this.state.isLogoutInProcess} />
            </div>
        )
    }

}

function mapStateToProps(state: StoreState) {
    return {
        isSigned: state.auth.isSigned
    }
}

function mapDispatchToProps(dispatch: Dispatch<RouterAction | ActionType | ErrorInfoActionType>) {
    return {
        routePush: (location: string) => dispatch(routerActions.push(location)),
        onErrorEvent: (errorInfo: ErrorInfo) => dispatch(ErrorActions.newError(errorInfo)),
        onLogOut: () => dispatch(Actions.logOut())
    }
}

export const LogOutContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(LogOut)



// WEBPACK FOOTER //
// ./src/containers/LogOutContainer.tsx